module.exports = __webpack_public_path__ + "static/img/02.1afa0640.png";